module.exports = __mpx_resolve_path__("/gaia/workspace-job/git.xiaojukeji.com/ut-prod/train-service/src/pages/contact/selectCountry.mpx?resolve")